import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  ICreateTransferPricingDocumentationParams,
  ICreateTransferPricingDocumentationResponse,
  TTransferPricingDocumentationMutationResult,
} from './types';

const FALLBACK_ERROR_MESSAGE =
  'Could not create the documentation record. Please try again.';

export const createTransferPricingDocumentation = (
  params: ICreateTransferPricingDocumentationParams,
  token?: string
): Promise<
  TTransferPricingDocumentationMutationResult<ICreateTransferPricingDocumentationResponse>
> =>
  TransferPricingDocumentationRequestHelper.send({
    path: TransferPricingDocumentationRequestHelper.BASE_PATH,
    method: 'POST',
    body: { ...params },
    isExpectedBody: TransferPricingDocumentationRequestHelper.isCreateResponse,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
    token,
  });
